import { Check } from 'lucide-react';

import type { BenefitsProps } from './useBenefits';

const BenefitsDesktop = ({ data }: BenefitsProps) => {
  return (
    <section id="benefits" className="flex h-[700px] w-full overflow-hidden">
      <div className="relative h-full w-[720px] flex-shrink-0 overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: `url(${data.backgroundImage})` }}
        />
      </div>

      <div className="flex flex-1 flex-col justify-center gap-10 bg-surface-primary p-20">
        <span className="font-body text-sm font-semibold tracking-widest text-accent-text">
          {data.label}
        </span>
        <h2 className="font-heading text-4xl font-medium leading-tight text-foreground-primary whitespace-pre-line">
          {data.title}
        </h2>

        <div className="flex flex-col gap-6">
          {data.benefits.map((benefit, index) => (
            <div key={index} className="flex items-center gap-4">
              <div className="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-full bg-accent-primary">
                <Check className="h-4 w-4 text-surface-inverse" />
              </div>
              <span className="font-body text-base text-foreground-primary">
                {benefit}
              </span>
            </div>
          ))}
        </div>

        <div className="flex gap-12">
          {data.stats.map((stat) => (
            <div key={stat.id} className="flex flex-col gap-1">
              <span className="font-heading text-4xl font-semibold text-accent-text">
                {stat.value}
              </span>
              <span className="font-body text-sm font-medium text-foreground-secondary">
                {stat.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BenefitsDesktop;
